// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class SetBool {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SetBool {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSetBool(bb: flatbuffers.ByteBuffer, obj?: SetBool): SetBool {
    return (obj || new SetBool()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSetBool(bb: flatbuffers.ByteBuffer, obj?: SetBool): SetBool {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SetBool()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  value(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startSetBool(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addValue(builder: flatbuffers.Builder, value: boolean) {
    builder.addFieldInt8(0, +value, null)
  }

  static endSetBool(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSetBool(builder: flatbuffers.Builder, value: boolean | null): flatbuffers.Offset {
    SetBool.startSetBool(builder)
    if (value !== null) SetBool.addValue(builder, value)
    return SetBool.endSetBool(builder)
  }
}
